import React, { useState , useEffect} from 'react';
import leaderImage from '../img/envision/aerospace/1635233089998.jpg';  // Import the image file
import BoardOfDirectorsnavbar from './BoardOfDirectorsnavbar';
import { FaLinkedin } from 'react-icons/fa';
import AboutLeadershipsecondcontainer from './AboutLeadershipsecondcontainer';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';
const Leadershipnagmohan = () => {
     const location = useLocation();
    
        useEffect(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }, [location]); // Run effect when the route changes
        
    return (
        <div>
            <div style={{ background: "rgb(236 115 34)", marginTop: "80px", height: "63px" }}>
                <h1 style={{ textAlign: "center", paddingTop: "13px" }}>OUR LEADERSHIP</h1>
            </div>
            {/* <BoardOfDirectorsnavbar />    */}
            <div style={styles.rowWrapper}>

                <div style={styles.row}>
                    <div style={styles.widgetSpan}>
                        <div id="hs_cos_wrapper_module_1564397675620228" style={styles.hsCosWrapper}>
                            {/* LazySizes Script */}
                            <script src="https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js" async=""></script>

                            <div style={styles.abMembers}>
                                <div style={styles.container}>
                                    <div style={styles.imageColumn}>
                                        <div style={styles.mImage}>
                                            {/* Use the imported image */}
                                            <img
                                                className="ls-is-cached lazyloaded"
                                                src={leaderImage}  // Use the imported image here
                                                alt="Naga Mohan Gollangi"
                                                style={styles.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={styles.textColumn}>
                                        <h1>Naga Mohan Gollangi</h1>
                                        <span>Advisory board member – BFSI</span>
                                        <br />

                                        {/* LinkedIn Icon */}
                                        <a href="https://www.linkedin.com/in/nagamohangollangi/" target="_blank" rel="noopener noreferrer">
                                            <FaLinkedin size={30} color="#0077B5" />
                                        </a>

                                    </div>
                                </div>
                            </div>

                            <div style={styles.memberParagraph}>
                                <div style={styles.container}>
                                    <div style={styles.col12}>
                                        <div style={styles.teamParagraph}>
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px' }}>Dr. Nagamohan Gollangi – Advisory Board Member - BFSI, DREBCON  </p>
                                            
                                            <p style={{ textAlign: 'justify', marginTop:'10px' }}>
                                            Dr. Nagamohan Gollangi is a renowned cybersecurity and IT governance expert with over 25 years of experience in information security, IT risk management, and banking technology. As the former Chief Information Security Officer (CISO) & Head of Global Centre at Bank of India, he played a pivotal role in strengthening cybersecurity frameworks, managing IT risks, and modernizing banking technology. 
                                            </p>
                                         
                                            <br></br>
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px',  }}>Currently, Dr. Naga mohan serves as: </p>
                                           
                                          
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                {/* <li style={{fontWeight:'bold'}}></li> */}
                                                <li style={{marginLeft:"30px"}}>Cyber Security Advisor – National Bank for Financing Infrastructure & Development (NaBFID) (A Government of India Financial Institution) </li>
                                                <li style={{marginLeft:"30px"}}>IT Advisor to Boards – STCI Finance & STCI Primary Dealer </li>
                                                <li style={{marginLeft:"30px"}}>Subject Matter Expert & Trainer – IGNOU, IIBF, IDRBT (Cybersecurity, IT Governance, AI, and Banking Technologies)  </li>
                                              
                                              
                                            
                                            </ul>

                                            <p style={{ textAlign: 'justify',marginTop:'10px', fontWeight:'bold' }}>
                                            Cybersecurity & IT Leadership 
                                            </p>
                                            <p style={{marginTop:'10px'}}>With a strong technical foundation, Dr. Gollangi has led IT infrastructure, network security, cloud security, and digital banking operations. His expertise spans: </p>
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                {/* <li style={{fontWeight:'bold'}}></li> */}
                                                <li style={{marginLeft:"30px"}}>Global Data Centre Management – IT architecture, storage (SAN), and banking applications  </li>
                                                <li style={{marginLeft:"30px"}}>Cybersecurity Strategy – Implementing cutting-edge security solutions including: </li>
                                                <li style={{marginLeft:"60px"}}>Cyber Security Operations Centre (CSOC)  </li>
                                                <li style={{marginLeft:"60px"}}>Network Behaviour Anomaly Detection (NBAD), Anti-DDoS, Anti-APT </li>
                                                <li style={{marginLeft:"60px"}}>Privileged User Management (PUM), Database Access Monitoring (DAM) </li>
                                                <li style={{marginLeft:"60px"}}>End-point Detection & Response (EDR), Security Orchestration Automated Response (SOAR) </li>
                                        
                                                <li style={{marginLeft:"60px"}}>Dark-Web Monitoring, Data Leakage Prevention (DLP), Deep Packet Inspection (DPI)  </li>
                                                <li style={{marginLeft:"60px"}}>Intrusion Prevention System (IPS), Web Application Firewall (WAF), DMARC for Email Security  </li>
                                              
                                                <li style={{marginLeft:"30px", marginTop:'10px'}}>Zero Trust Architecture Implementation – Network micro-segmentation, Identity & Access Management (IDAM) </li>
                                                <li style={{marginLeft:"30px",}}>Enterprise-Wide Fraud Risk Management (EFRM)  </li>

                                            </ul>
                                            <p style={{ textAlign: 'justify',marginTop:'10px', fontWeight:'bold' }}>
                                            Academic & Professional Excellence 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px'}}>Dr. Naga mohan’s academic credentials include:  </p>
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                {/* <li style={{fontWeight:'bold'}}></li> */}
                                                <li style={{marginLeft:"30px"}}>PhD – University of Bristol (Focused on financial technologies and cybersecurity advancements)  </li>
                                                <li style={{marginLeft:"30px"}}>Master of Science (MS) in Physical Chemistry – Andhra University </li>
                                                <li style={{marginLeft:"30px"}}>Master’s Degree in Science – Andhra University (Grade: First)  </li>

                                        
                                            
                                            </ul>
                                        
                                    
                                          


                                         
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', marginTop:'20px'}}>
                                            Industry Certifications & Recognitions 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>Dr. Gollangi holds globally recognized certifications in cybersecurity and IT governance: </p>
                                           
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                               
                                                <li style={{marginLeft:"30px"}}><b>Certified Information Systems Auditor (CISA) – ISACA </b> </li>
                                                <li style={{marginLeft:"30px"}}><b>Certified Information Security Manager (CISM) – ISACA  </b></li>
                                                <li style={{marginLeft:"30px"}}><b>Certified Ethical Hacker (CEH) – EC-Council </b> </li>
                                                <li style={{marginLeft:"30px"}}><b>ISO 22301 Lead Auditor – Business Continuity Management Systems (BCMS) </b> </li>
                                                <li style={{marginLeft:"30px"}}><b>CAIIB, PGDFM (Banking & Financial Management) </b></li>
                                                

             
                                            </ul>

                                            <p style={{ textAlign: 'justify', fontWeight:'bold',  marginTop:'20px'}}>
                                            Thought Leadership & Publications 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px' }}>Dr. Gollangi is a respected author, speaker, and cybersecurity trainer, actively contributing to industry knowledge: </p>
                                           
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                               
                                                <li style={{marginLeft:"30px"}}>Author of Books on IT & Information Security – IGNOU, IIBF </li>
                                                <li style={{marginLeft:"30px"}}>Guest Faculty & Trainer – IIBF, IDRBT, RBI STCs </li>
                                                <li style={{marginLeft:"30px"}}>Reviewer of Industry Publications – Banking Technology & Cybersecurity </li>
                                                <li style={{marginLeft:"30px"}}>Speaker & Moderator – Over 11 years of engagements in technology forums, banking summits, and cybersecurity conferences  </li>

                                                

             
                                            </ul>


                                            <p style={{ textAlign: 'justify',marginTop:'10px', fontWeight:'bold',  }}>
                                            Strategic Vision at DREBCON 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px'}}>As an Advisory Board Member at DREBCON, Dr. Gollangi brings unparalleled expertise in cybersecurity, IT governance, risk management, and digital transformation. His strategic vision and leadership will drive next-gen AI-driven cybersecurity solutions, ensuring businesses stay resilient against evolving digital threats  </p>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
            </div>
            <AboutLeadershipsecondcontainer />
            <Footer />
        </div>
    );
};

const styles = {
    rowWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
        marginTop: '46px',
    },
    row: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '1200px',
    },
    widgetSpan: {
        padding: '20px',
    },
    hsCosWrapper: {
        marginBottom: '30px',
    },
    abMembers: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '20px',
    },
    container: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
    },
    imageColumn: {
        flex: 1,
        paddingRight: '20px',
    },
    mImage: {
        width: '100%',
    },
    image: {
        width: '86%',
        borderRadius: '8px',
        border: '1px solid'
    },
    textColumn: {
        flex: 2,
        paddingLeft: '20px',
        display: 'flex',               // Add display flex to enable flexbox layout
        flexDirection: 'column',       // Arrange children in a column
        justifyContent: 'center',     // Vertically center the content
        // alignItems: 'center',         
        // textAlign: 'center',       
    },
    socialLink: {
        display: 'inline-block',
        marginTop: '10px',
    },
    socialIcon: {
        width: '30px',
        height: '30px',
    },
    memberParagraph: {
        padding: '20px',
    },
    col12: {
        width: '100%',
    },
    teamParagraph: {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#333',
        textAlign: 'justify',  // Added text alignment as justify
    },
};

export default Leadershipnagmohan;
